<template>
  <div id="box" class="error">
    <div class="inner">
      <div class="scrollWrapper">
        <h1 v-html="title" />
        <p v-html="description" class="description" />
        <div class="expandWrapper">
          <img
            v-svg-inline
            class="img"
            src="../assets/imgs/error.svg"
            alt="error"
          />
        </div>
      </div>
      <CustomButton
        :buttonType="'accent'"
        :customButtonTxt="customButton"
        @submit="back"
        v-if="hasCustomButton"
      />
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
export default {
  name: "Error",
  components: {
    CustomButton,
  },
  props: {
    errorType: {
      type: String,
      default: "canceled",
    },
    redirectURL: {
      type: String,
      default: "",
    },
  },
  mounted() {
    localStorage.removeItem("login_challenge");
  },
  computed: {
    title() {
      return this.$t("authorizationError." + this.errorType + ".title");
    },
    description() {
      return this.$t("authorizationError." + this.errorType + ".description");
    },
    customButton() {
      if (this.errorType == "consentFailed") {
        return this.$t("customButton.again");
      }
      return this.$t("customButton.return");
    },
    hasCustomButton() {
      switch (this.errorType) {
        case "reuse":
          return false;
        case "wrongCode":
          if (this.redirectURL == "") {
            return false;
          }
          return true;
        default:
          return true;
      }
    },
  },
  methods: {
    back() {
      switch (this.errorType) {
        case "wrongCode":
        case "canceled":
        case "expired":
        case "smartPOSTNotSupported":
          window.location = this.redirectURL;
          break;
        case "consentFailed":
          this.$emit("retry");
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper
    +flex()
    .img
      +size(100px)
  .wrapper
    +flex(space-between, center, row)
</style>